<template>
    <c-input-element class="c-form-element__radio" :label="label" :helptext="helptext" :class="{ 'c-form-element--horizontal' : horizontal }" :name="name">
        <div :class="[(block ? 'c-form-radio-block' : 'c-form-radio')]">
            <div class="c-form-radio__option" v-for="(option,index) in options" :key="'option' + name + index">
                <input
                    type="radio"
                    :data-error-container="'#' + name + '-error-container'"
                    v-model="value"
                    :name="name + '-' + $.uid"
                    :required="required"
                    :value="option.value"
                    :id="name + '-' + index + '-' + $.uid"
                />
                <label :for="name + '-' + index + '-' + $.uid">
                    <div>{{option.label}}</div>
                    <div class="c-form-radio__helptext font-primary fs-small">{{option.helptext}}</div>
                </label>
            </div>
        </div>
        <div class="c-form__error" :id="name + '-error-container'">Selecteer een optie.</div>
    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';
import Helpers from '@support/Helpers';

export default {
    name: 'form-radiogroup-input',
    mixins: [Input],
    props: {
        options: {
            type: Array,
            required: true
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        },
        horizontal: {
            type: Boolean,
            default: false
        },
        name: {
            type:String,
            default: () => Helpers.uid()
        }
    }
}
</script>
